const bootstrap = require('bootstrap');

document.addEventListener("DOMContentLoaded", function() {
    //document.body.innerHTML = document.body.innerHTML.replace(/CARTE Assurances/g, '<span style="white-space: nowrap;">CARTE Assurances</span>');

    let megaElements = document.getElementsByClassName("mega-menu")
    let bodyclientWidth = document.getElementsByTagName("body")[0].clientWidth
    Array
        .from(megaElements)
        .forEach(function (megaElement) {
            let linkPos = parseInt(megaElement.parentElement.getElementsByClassName("mega-menu-link")[0].getBoundingClientRect().left);
            let leftPost = (linkPos - 50 )

            let check = megaElement.getElementsByTagName("li")[0].getElementsByClassName("mega-sub-item").length;

            let liWidth = 270
            if(check > 6){
                megaElement.getElementsByTagName("li")[0].style.maxWidth = (270*3) + "px"
                if(check > 3){check = 3}
                liWidth = check * 270
            }else{
                if(check > 2){check = 2}
                liWidth = check * 270
            }


            if(bodyclientWidth > liWidth + leftPost){
                megaElement.getElementsByTagName("li")[0].style.left = leftPost + "px"
            }else{
                leftPost = bodyclientWidth - liWidth - 20
                megaElement.getElementsByTagName("li")[0].style.left = leftPost + "px"
            }


            let aLeft = megaElement.parentElement.getElementsByClassName("mega-menu-link")[0].getBoundingClientRect().left;
            megaElement.parentElement.getElementsByClassName("mega-item-fa")[0].style.left = (aLeft - leftPost ) + "px"

        })

    setTimeout(function () { forceParentHeight() }, 200)
    let servicePrices = document.getElementsByClassName("service-prices")
    let servicePricesTable = document.getElementsByClassName("service-prices-table")
    let titleScrollTop = 0
    let titleScrollBottom = 0
    let mobileTitleScrollTop = 0
    let mobileTitleScrollBottom = 0
    let mobileHeader = null;
    let packOptions = null;

    if(servicePrices.length > 0){
        servicePrices = servicePrices[0];
        servicePricesTable = servicePricesTable[0];
        titleScrollTop = servicePrices.offsetTop;
        titleScrollBottom = servicePrices.offsetTop + servicePricesTable.offsetHeight;
        mobileHeader = servicePricesTable.getElementsByClassName("tabs-header");
        mobileHeader = mobileHeader[0];

        packOptions = servicePricesTable.getElementsByClassName("pack-options");
        packOptions = packOptions[0];

        mobileTitleScrollTop = packOptions.getBoundingClientRect().y - 250
    }else{
        servicePrices = false;
    }

    let fixToBottoms = document.getElementsByClassName("fix-to-bottom")
    let fixTopMenu = document.getElementById("fix-top-menu")
    let fixTopMenuOffsetTop = fixTopMenu.offsetTop;

    let topSb = document.getElementById("top-simulation-button")
    let bottomSb = document.getElementById("bottom-simulation-button")


    let scrollLeft = document.getElementsByClassName("scroll-left")
    let scrollRight = document.getElementsByClassName("scroll-right")

    Array
        .from(scrollLeft)
        .forEach(function (btn) {
            if(typeof btn.dataset !== "undefined" && btn.dataset.element !== "undefined"){
                let elm = document.getElementById(btn.dataset.element)
                if(elm){
                    btn.addEventListener("click", function(){
                        elm.scrollTo({
                            left: elm.scrollLeft - 220,
                            behavior: 'smooth',
                        });
                    })
                }
            }
        })

    Array
        .from(scrollRight)
        .forEach(function (btn) {
            if(typeof btn.dataset !== "undefined" && btn.dataset.element !== "undefined"){
                let elm = document.getElementById(btn.dataset.element)
                if(elm){
                    btn.addEventListener("click", function(){
                        elm.scrollTo({
                            left: elm.scrollLeft + 220,
                            behavior: 'smooth',
                        });
                    })
                }
            }
        })


    //resolveHomeSliderButtons()
    window.onscroll = function() {

        if(topSb && bottomSb){
            if(topSb.getBoundingClientRect().y < 0){
                if(!bottomSb.classList.contains("visible")){
                    bottomSb.classList.add("visible")
                }
            }else{
                if(bottomSb.classList.contains("visible")){
                    bottomSb.classList.remove("visible")
                }
            }
        }

        forceParentHeight()
        if(fixTopMenu){
            if(window.scrollY <= fixTopMenuOffsetTop){
                fixTopMenu.classList.remove("fixed")
            }else{
                let topPostion = fixTopMenu.getBoundingClientRect().y
                if(topPostion <= 0){
                    fixTopMenu.classList.add("fixed")
                }
            }
        }

        Array
            .from(fixToBottoms)
            .forEach(function (fixToBottom) {
                if(fixToBottom){
                    let pos = window.innerHeight - fixToBottom.getBoundingClientRect().y - fixToBottom.offsetHeight;
                    if(pos >= 100 ){
                        fixToBottom.classList.add("fixed")
                    }else{
                        fixToBottom.classList.remove("fixed")
                    }
                }
            })

        if(servicePrices){
            let scrollTop = document.documentElement.scrollTop;

            if(scrollTop >= titleScrollTop){
                servicePrices.classList.add("fixed-titles")
            }else{
                servicePrices.classList.remove("fixed-titles")
            }

            if(scrollTop >= titleScrollBottom){
                servicePrices.classList.add("fixed-titles-hidden")
            }else{
                servicePrices.classList.remove("fixed-titles-hidden")
            }

            mobileTitleScrollTop = packOptions.getBoundingClientRect().y - 250
            mobileTitleScrollBottom = mobileTitleScrollTop + packOptions.offsetHeight + 90

            if(0 >= mobileTitleScrollTop){
                mobileHeader.classList.add("fixed-titles")
                packOptions.classList.add("fixed-titles")
            }else{
                mobileHeader.classList.remove("fixed-titles")
                packOptions.classList.remove("fixed-titles")
            }

            if(mobileTitleScrollBottom <= 0){
                mobileHeader.classList.add("fixed-titles-hidden")
            }else{
                mobileHeader.classList.remove("fixed-titles-hidden")
            }
        }
    };

    function positionSuccess(position) {
        let latitude  = position.coords.latitude;
        let longitude = position.coords.longitude;

        if(typeof agenciesMap !== "undefined"){
            if(typeof L !== "undefined"){

                let positionIcon = L.icon({
                    iconUrl: assetsUrl + "/assets/images/icons/marker.svg",
                    iconSize: [26, 36], // size of the icon
                    iconAnchor: [13, 18], // point of the icon which will correspond to marker's location
                });

                let marker = L.marker([latitude, longitude], { icon: positionIcon }).bindTooltip('<div>Choisir cetter agence</div>');

                L.featureGroup([marker])
                    .addTo(agenciesMap);

                agenciesMap.setView([latitude, longitude], 13);
            }
        }

        if(typeof googleAgenciesMap !== "undefined"){
            if(typeof google.maps.Marker !== "undefined"){

                let myLatLng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
                let iconImage = assetsUrl + "/assets/images/icons/marker.svg";

                let marker = new google.maps.Marker({
                    position: myLatLng,
                    map: googleAgenciesMap,
                    icon: iconImage
                });

                googleAgenciesMap.setZoom(14);
                googleAgenciesMap.setCenter(marker.getPosition());
            }
        }
    }

    function positionError() {
        console.log('Unable to retrieve your location')
    }

    function localizeMe() {

        if (!navigator.geolocation) {
            console.log('Geolocation is not supported by your browser')
        } else {
            navigator.geolocation.getCurrentPosition(positionSuccess, positionError, {enableHighAccuracy : true});
        }

    }

    let localizeMeButtons = document.getElementsByClassName("localize-me");

    Array
        .from(localizeMeButtons)
        .forEach(function (localizeMeButton) {
            localizeMeButton.addEventListener("click", function(){
                localizeMe()
            })
        })

})

document.addEventListener("DOMContentLoaded", function() {

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    //Bootstrap accordion fix
    let autoAddCollapsedClass = function(accordionButton){
        let accordionItem = accordionButton.closest(".accordion-item")
        let accordionCollapse = accordionItem.getElementsByClassName("accordion-collapse")
        accordionCollapse = accordionCollapse[0]

        if(accordionCollapse.classList.contains("show")){
            accordionItem.classList.add("collapsed")
        }else{
            accordionItem.classList.remove("collapsed")
        }

    }

    let resolveAllCollapsed = function(delay){
        let accordionButtons = document.getElementsByClassName('accordion-button');
        if(accordionButtons.length > 0){

            Array
                .from(accordionButtons)
                .forEach(function (accordionButton) {
                    setTimeout(function(){
                        autoAddCollapsedClass(accordionButton)
                    }, delay)
                })
        }
    }

    let accordionButtons = document.getElementsByClassName('accordion-button');
    if(accordionButtons.length > 0){

        Array
            .from(accordionButtons)
            .forEach(function (accordionButton) {
                accordionButton.addEventListener("click", function(){
                    resolveAllCollapsed(400)
                })
            })
    }

    resolveAllCollapsed(0)

    //Home Banner tabs
    let topNavSelectors = document.querySelectorAll('.banner-menu .menu-item')
    let topNavTabs = document.querySelectorAll('.banner-tabs .tab')

    Array
        .from(topNavSelectors)
        .forEach(function (element) {
            element.addEventListener('click', function () {
                Array.from(topNavSelectors).forEach(function (elm) {
                    elm.classList.remove('active');
                })

                Array.from(topNavTabs).forEach(function (elm) {
                    elm.classList.remove('active');
                })

                let id = element.id;
                element.classList.add('active');

                document.getElementById('tab-' + id).classList.add('active')
                //resolveHomeSliderButtons()
            })
        })

    // Lazy Load Images
    let lazyLoadThrottleTimeout;

    function lazyLoad () {
        let lazyLoadImages = document.querySelectorAll("img.lazy");
        if(lazyLoadThrottleTimeout) {
            clearTimeout(lazyLoadThrottleTimeout);
        }

        lazyLoadThrottleTimeout = setTimeout(function() {

            var scrollTop = window.pageYOffset;
            lazyLoadImages.forEach(function(img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');

                    if(img.classList.contains("blur-background")){
                            let blurImage = document.createElement("img")
                            let parentElement = img.parentElement
                            blurImage.src = img.dataset.src
                            blurImage.classList.add("blur-background-image")
                            parentElement.insertBefore(blurImage, img)
                    }
                }
            });

            if(lazyLoadImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationChange", lazyLoad);
            }

        }, 20);
    }

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationChange", lazyLoad);
    lazyLoad()

    // Table Tabs eg: service details
    let tableTabsNavigation = function(tableTabs, tableTabsFollow){
        let activeTabHeader = tableTabs.getElementsByClassName("active")
        if(activeTabHeader.length > 0){
            activeTabHeader = activeTabHeader[0]
            let tabIndex = parseInt(activeTabHeader.dataset.index);
            let startIndex = parseInt(activeTabHeader.dataset.start);
            tabIndex += startIndex;

            let tabRows = tableTabs.getElementsByTagName("tr")
            let allRows = [];
            if(tabRows.length > 0){
                allRows.push(tabRows)
            }

            if(tableTabsFollow){
                Array.prototype.forEach.call(tableTabsFollow, function(follow) {
                    let followRows = follow.getElementsByTagName("tr");

                    if(followRows.length > 0){
                        allRows.push(followRows)
                    }
                })
            }


            if(allRows.length > 0){

                Array.prototype.forEach.call(allRows, function(rows) {

                    Array.prototype.forEach.call(rows, function(row) {
                        if(!row.classList.contains('tabs-header') && !row.classList.contains('tabs-ignore')){

                            let cells = row.getElementsByTagName("td")
                            if(cells.length > 0){

                                Array.prototype.forEach.call(cells, function(cell) {

                                    cell.classList.remove("active")
                                    let cellIndex = parseInt(cell.cellIndex) + 1

                                    if(cellIndex < startIndex || cellIndex === tabIndex){
                                        cell.classList.add("active")
                                    }
                                });
                            }
                        }
                    });
                });
            }
        }
    }

    let tableTabs = document.getElementsByClassName("table-tabs");
    if(tableTabs.length > 0){
        Array.prototype.forEach.call(tableTabs, function(tableTab) {
            let tabHeaders = tableTab.getElementsByClassName("tabs-header")
            if(tabHeaders.length > 0){

                let tableTabsFollow = null;
                if(typeof tableTab.dataset.follow !== "undefined"){
                    tableTabsFollow = document.getElementsByClassName(tableTab.dataset.follow)
                }

                Array.prototype.forEach.call(tabHeaders, function(tabHeader) {
                    tabHeader.addEventListener("click", function (event) {
                        let cells = tabHeader.getElementsByTagName("td")

                        Array.prototype.forEach.call(cells, function(cell) {
                            cell.classList.remove("active")
                        });

                        event.target.closest("td").classList.add("active")
                        tableTabsNavigation(tableTab, tableTabsFollow)
                    })
                });

                tableTabsNavigation(tableTab, tableTabsFollow)
            }
        });
    }

    let stepsNavigators = document.getElementsByClassName("steps-navigation");

    let calculateStepProgress = function(){
        return '25%';
    }

    let selectStep = function(currentIndex, formId){
        let allLis = document.getElementsByClassName("step-li-" + formId)

        Array.prototype.forEach.call(allLis, function(li) {
            li.classList.remove("done")
            li.classList.remove("current")

            let thisIndex = li.dataset.index
            let formId = li.dataset.id

            let progressBars = li.getElementsByClassName('progress')

            if(thisIndex < currentIndex){
                li.classList.add("done")
            }else if(thisIndex === currentIndex){
                li.classList.add("current")

                Array.prototype.forEach.call(progressBars, function(progressBar) {
                    let tabs = document.getElementsByClassName("step-tab-" + formId);
                    Array.prototype.forEach.call(tabs, function(tab) {
                        tab.classList.remove("current")
                        if(tab.dataset.index === currentIndex){
                            tab.classList.add("current")
                        }
                    })
                    setTimeout(function (args) {
                        progressBar.style.width = calculateStepProgress(thisIndex, formId)
                    }, 500)
                })

            }else{
                Array.prototype.forEach.call(progressBars, function(progressBar) {
                    progressBar.style.width = 0
                })
            }
        });
    }

    if(stepsNavigators && stepsNavigators.length > 0){

        Array.prototype.forEach.call(stepsNavigators, function(stepsNavigator) {
            let stepsIndexes = stepsNavigator.getElementsByClassName("step-index");
            Array.prototype.forEach.call(stepsIndexes, function(stepsIndex) {
                stepsIndex.addEventListener("click", function(){
                    let forms = document.getElementsByClassName("step-tab-" + stepsIndex.dataset.id)
                    let currentStep = null;
                    Array.prototype.forEach.call(forms, function(form) {
                        if(form.classList.contains("current")){
                            currentStep = form;
                        }
                    });

                    if(currentStep.dataset.index < stepsIndex.dataset.index && !validateStep(stepsIndex.dataset.id, currentStep.dataset.index)){
                        return false;
                    }

                    selectStep(stepsIndex.dataset.index, stepsIndex.dataset.id)
                });
            });
        });
    }

    let textInput = document.getElementsByClassName("text-input");
    Array.prototype.forEach.call(textInput, function(div) {
        let inputs = div.getElementsByTagName("input");
        Array.prototype.forEach.call(inputs, function(input) {
            input.addEventListener("DOMFocusOut", function () {
                console.log('input.value.length' + input.value)
                div.classList.remove("empty")
                if(input.value.length === 0){
                    div.classList.add("empty")
                }
            })
        });

        let selects = div.getElementsByTagName("select");
        Array.prototype.forEach.call(selects, function(select) {
            select.addEventListener("change", function () {
                div.classList.remove("empty")
                if(select.value.length === 0){
                    div.classList.add("empty")
                }
            })
        });

        let textareas = div.getElementsByTagName("textarea");
        Array.prototype.forEach.call(textareas, function(textareaInput) {
            textareaInput.addEventListener("keyup", function () {
                div.classList.remove("empty")
                if(select.value.length === 0){
                    div.classList.add("empty")
                }
            })
        });


    });

    let radioInput = document.getElementsByClassName("radio-input");
    Array.prototype.forEach.call(radioInput, function(div) {
        let inputs = div.getElementsByTagName("input");
        Array.prototype.forEach.call(inputs, function(input) {
            input.addEventListener("change", function () {
                Array.prototype.forEach.call(radioInput, function(div) {
                    let inputs = div.getElementsByTagName("input");
                    Array.prototype.forEach.call(inputs, function(input) {
                        div.classList.remove("checked")
                        if(input.checked){
                            div.classList.add("checked")
                        }
                    });
                });
            })
        });
    });

    let prevStep = document.getElementsByClassName("prev-step");
    let nextStep = document.getElementsByClassName("next-step");
    let submitForm = document.getElementsByClassName("submit-form");

    let validateStep = function (formId, currentIndex) {

        let form = document.getElementsByClassName("step-tab-" + currentIndex + "-" + formId)
        form = form[0];
        let isValid = true;
        let inputs = form.getElementsByTagName("input");
        let selects = form.getElementsByTagName("select");
        let checkboxGroups = form.getElementsByClassName("checkbox-group-required")

        Array.prototype.forEach.call(inputs, function(input) {
            if(
                isValid && (
                    typeof input.type === "undefined" ||
                    input.type === "text" ||
                    input.type === "number" ||
                    input.type === "email" ||
                    input.type === "radio"
                )
            ){
                let input_reportValidity = input.reportValidity()
                isValid = isValid && input_reportValidity
                if(!input_reportValidity){
                    let parent = input.parentNode
                    parent.classList.add("has-error")
                }
            }
        });

        console.log(isValid)
        Array.prototype.forEach.call(selects, function(select) {
            if(isValid){
                isValid = isValid && select.reportValidity()
            }
        });

        Array.prototype.forEach.call(checkboxGroups, function(checkboxGroup) {
            if(isValid){
                let inputs = checkboxGroup.getElementsByTagName("input");

                let isChecked = false;
                Array.prototype.forEach.call(inputs, function(input) {
                    inputs.required = true;
                    isChecked = isChecked || input.checked
                });

                if(!isChecked){
                    inputs[0].required = true;
                    inputs[0].reportValidity()
                }

                isValid = isValid && isChecked;
            }
        });

        return isValid;
    }

    let goToStep = function (button, next) {
        let formId = button.dataset.id;
        let currentIndexDiv = document.getElementsByClassName("step-tab-" + formId)

        let currentIndex = null;
        if(currentIndexDiv.length > 0){

            Array.prototype.forEach.call(currentIndexDiv, function(div) {
                if(div.classList.contains("current")){
                    currentIndex = div;
                }
            });

            let isLastStep = currentIndex.dataset.laststep
            let isFirstStep = currentIndex.dataset.firststep
            currentIndex = currentIndex.dataset.index

            if(next){
                if(isLastStep === "0"){
                    if(!validateStep(formId, currentIndex)){
                        return ;
                    }
                    currentIndex = "" + (parseInt(currentIndex) + 1);
                    selectStep(currentIndex, formId);
                }
            }else{
                if(isFirstStep === "0"){
                    currentIndex = "" + (parseInt(currentIndex) - 1);
                    selectStep(currentIndex, formId);
                }
            }

            currentIndexDiv = document.getElementsByClassName("step-tab-" + formId)
            Array.prototype.forEach.call(currentIndexDiv, function(div) {
                if(div.classList.contains("current")){
                    currentIndex = div;
                }
            });

            Array.prototype.forEach.call(nextStep, function(btn) {
                if(btn.dataset.id === formId){
                    btn.style.display = "inline-block";
                }
            });
            Array.prototype.forEach.call(prevStep, function(btn) {
                if(btn.dataset.id === formId){
                    btn.style.display = "inline-block";
                }
            });
            Array.prototype.forEach.call(submitForm, function(btn) {
                if(btn.dataset.id === formId){
                    btn.style.display = "none";
                }
            });

            if(currentIndex.dataset.laststep === "1"){
                Array.prototype.forEach.call(nextStep, function(btn) {
                    if(btn.dataset.id === formId){
                        btn.style.display = "none";
                    }
                });
                Array.prototype.forEach.call(submitForm, function(btn) {
                    if(btn.dataset.id === formId){
                        btn.style.display = "inline-block";
                    }
                });
            }

            if(currentIndex.dataset.firststep === "1"){
                Array.prototype.forEach.call(prevStep, function(btn) {
                    if(btn.dataset.id === formId){
                        btn.style.display = "none";
                    }
                });
            }
        }
    }

    if(prevStep.length > 0){
        Array.prototype.forEach.call(prevStep, function(button) {
            button.addEventListener("click", function(){
                goToStep(button, false)
            })
        });
    }

    if(nextStep.length > 0){
        Array.prototype.forEach.call(nextStep, function(button) {
            button.addEventListener("click", function(){
                goToStep(button, true)
            })
        });
    }

    if(submitForm.length > 0){
        Array.prototype.forEach.call(submitForm, function(button) {
            button.addEventListener("click", function(e){

                let form = document.getElementById("form-" + e.target.dataset.id);

                if(form.checkValidity()){
                    if(grecaptcha.getResponse().length > 0){
                        form.submit();
                    }else{
                        document.getElementById("captcha-alert-" + e.target.dataset.id).style.display = "block";
                    }
                }else{
                    form.reportValidity()
                }
            })
        });
    }

    var uploadFields = document.getElementsByTagName("input");
    Array.prototype.forEach.call(uploadFields, function(uploadField) {
        if(uploadField.type !== "file"){
            return ;
        }

        uploadField.addEventListener("change", function () {
            if(typeof this.dataset.maxsize === "undefined" || !this.dataset.maxsize){
                return;
            }
            if(this.files[0].size > parseInt(this.dataset.maxsize)){
                alert(this.dataset.sizemessage);
                this.value = "";
            }
        })
    })


});

var forceParentHeight = function(){
    let elements = document.getElementsByClassName("force-parent-height")


    Array.prototype.forEach.call(elements, function(element) {
        let childs = element.getElementsByClassName("child-height")
        let height = 0
        Array.prototype.forEach.call(childs, function(item) {
            item.style.height = "auto";
        })

        Array.prototype.forEach.call(childs, function(item) {
            height = Math.max(height, item.clientHeight)
        })

        Array.prototype.forEach.call(childs, function(item) {
            item.style.height = height + "px";
        })
    })

}



// var resolveHomeSliderButtons = function(){
//     let homeBannerSliders = document.getElementsByClassName("home-banner-slider")
//     if(homeBannerSliders){
//         Array
//             .from(homeBannerSliders)
//             .forEach(function (homeBannerSlider) {
//                 let homeBannerContainer = homeBannerSlider.getElementsByClassName("home-banner-container")
//                 homeBannerContainer = homeBannerContainer[0]
//                 let ul = homeBannerContainer.getElementsByTagName("ul")
//                 ul = ul[0]

//                 let parent = ul.parentNode
//                 if(ul.scrollWidth > ul.clientWidth){
//                     parent.classList.add("has-scroll")
//                 }else{
//                     parent.classList.remove("has-scroll")
//                 }
//             })
//     }
// }

document.addEventListener("DOMContentLoaded", function() {
    let btnscale = document.getElementsByClassName('dropdown scale');
    if(btnscale){
        btnscale[0].addEventListener("click", function(){
            let menu = document.getElementsByClassName('scale-menu');
            let arrow = document.getElementsByClassName('arrow');
            let type_link = document.getElementsByClassName('type-link nav-link');
            let button = document.getElementById('navbarSupportedContent').getElementsByClassName('button');
            let btnscale = document.getElementsByClassName('dropdown scale');
            menu[0].classList.toggle("clicked-menu")
            arrow[0].classList.toggle("clicked-arrow")
            button[0].classList.toggle("clicked-button")
            type_link[0].classList.toggle("clicked-type_link")
            btnscale[0].classList.toggle("clicked-btnscale")
        })
    }

})
document.addEventListener("DOMContentLoaded", function() {
    let hamburger_menu = document.getElementsByClassName('hamburger_menu');
    if(hamburger_menu){
        hamburger_menu[0].addEventListener("click", function(){
            let hasdisabledclass = document.getElementsByTagName("body")[0].classList.contains('disabled-body');
            if(hasdisabledclass)
            {
                document.getElementsByTagName("body")[0].classList.remove("disabled-body")
                document.getElementsByClassName("mobile-background")[0].classList.remove("disabled-page")
            }
            else
            {
                document.getElementsByTagName("body")[0].classList.add("disabled-body")
                document.getElementsByClassName("mobile-background")[0].classList.add("disabled-page")

            }
        })
    }


    let search = document.getElementsByClassName('open-search');
    if(search && search.length){
        search[0].addEventListener("click", function(){
            
            let hasopenclass = document.getElementsByClassName("search-input")[0].classList.contains('open-search');
            if(hasopenclass)
            {
                document.getElementsByClassName("search-input")[0].classList.remove("open-search")
                document.getElementsByClassName("floating-log")[0].classList.remove("hidden-logo")
            }
            else
            {
                document.getElementsByClassName("search-input")[0].classList.add("open-search")
                document.getElementsByClassName("floating-log")[0].classList.add("hidden-logo")
            }
        })
    }

})

var btnTop = document.querySelector('#topBtn');

var btnReveal = function () { 
  if (window.scrollY > 300) {
    btnTop.classList.add('visible');
  } else {
    btnTop.classList.remove('visible');
  }    
}  
// Thanks to => http://stackoverflow.com/a/22610562
var TopscrollTo = function () {
  if(window.scrollY!=0) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
window.addEventListener('scroll', btnReveal);
btnTop.addEventListener('click', TopscrollTo); 

